module.exports = __webpack_public_path__ + "static/media/Voyage soffa 4-sits cozy grön miljö modell 2024.c4f1df10.jpg";